// Module
var code = "<h2 id=\"change-due-date\">Change Due Date</h2> <p>If you struggle to make payments on time, consider changing your due date to ensure you have sufficient funds available when it&#39;s time to pay your bill. </p> ";
// Exports
export default code;